/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';

import type {
  FilterOptionsList
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Blueprint materials filter
 */
export const filtersBlueprintsMaterials = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOptionsList>(
      {url: `/filters/blueprints/materials`, method: 'GET', signal
    },
      );
    }




export const getFiltersBlueprintsMaterialsQueryKey = () => {
    return [
    'filters','blueprints','materials'
    ] as const;
    }


export const getFiltersBlueprintsMaterialsQueryOptions = <TData = Awaited<ReturnType<typeof filtersBlueprintsMaterials>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filtersBlueprintsMaterials>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFiltersBlueprintsMaterialsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof filtersBlueprintsMaterials>>> = ({ signal }) => filtersBlueprintsMaterials(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof filtersBlueprintsMaterials>>, TError, TData>
}

export type FiltersBlueprintsMaterialsQueryResult = NonNullable<Awaited<ReturnType<typeof filtersBlueprintsMaterials>>>
export type FiltersBlueprintsMaterialsQueryError = ErrorType<unknown>


/**
 * @summary Blueprint materials filter
 */

export function useFiltersBlueprintsMaterials<TData = Awaited<ReturnType<typeof filtersBlueprintsMaterials>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filtersBlueprintsMaterials>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFiltersBlueprintsMaterialsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






